import * as React from "react";

function CopyDone(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 385 236" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M368.208 0a16 16 0 00-9.92 3.52L115.6 190.752 28.848 83.456A16.002 16.002 0 005.96 80.534a16.001 16.001 0 00-2.008 22.986L110.32 235.264 377.904 28.832a16.002 16.002 0 00-.303-25.822c-2.74-1.956-6.027-3.03-9.393-3.01z"
        fill="var(--color-blue-500)"
      />
    </svg>
  );
}

const MemoCopyDone = React.memo(CopyDone);
export default MemoCopyDone;
